module.exports = __webpack_public_path__ + "static/media/pool-skimmer-image-2.15a9ed81.jpg";